import './Header.css'
import React from "react";
import { Navbar, Container } from "react-bootstrap";
import { Row, Col } from 'react-bootstrap';
import { useTheme } from "../Context/ThemeContext";
import{ReactComponent as Notification} from "../Icons/bell.svg";
import{ReactComponent as Languages} from "../Icons/Languages.svg";
import{ReactComponent as MagnifyingGlass} from "../Icons/magnifying-glass.svg";
import{ReactComponent as Kletter} from "../Icons/K.svg";
import{ReactComponent as CaretDownIcon} from"../Icons/caret-down.svg";
import { useAuth, SignOutButton } from '../Auth/AuthProvider';
import { Link } from 'react-router-dom';


function Header() {

    const { toggleTheme, theme } = useTheme();
    const auth = useAuth();
    const name = auth?.user?.displayName || auth?.user?.email || 'Account';
    const logoSrc = theme === "dark" ? "/Logo/Logo_Dark.png" : "/Logo/Logo_light.png";
    return (<>

        <Navbar>
            <Container>
                <Row className="header">
                    <Col md={2} className="CompanyLogo">
                        <div className="logo">
                            <img src={logoSrc} className="logoImage" alt="Cobygo" width="628" height="202" />
                        </div>
                        <div>
                        </div>

                    </Col>
                    {/* <Col md={6} className="Searchbar">
                        <MagnifyingGlass className='headerIcons' />
                        <input type="text" className="SearchInput" placeholder="Search tools (Ctrl + K)"></input>
                        <Languages className='headerIcons' />
                        <Kletter className='headerIcons' />
                    </Col> */}
                    <Col md={2} className="userProfile">
                        <img
                            src={theme === "dark" ? "/Sun.svg" : "/Moon.svg"}
                            onClick={toggleTheme}
                            className="themeToggleIcon"
                            alt={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
                        />
                        {/* <Notification className='headerIcons'/> */}
                        <details className="auth-account-menu"><summary className="UserName" aria-label="Account menu">
                            <span className="Initial">{name.slice(0, 2).toUpperCase()}</span>
                            <span className="Name">{name.split(' ')[0]}</span>
                            <CaretDownIcon className='headerIcons'/>
                        </summary><nav aria-label="Account">
                          {auth?.user?.roles.includes('TENANT_ADMIN') && <Link to="/app/admin">Tenant administration</Link>}
                          {auth && <SignOutButton />}
                        </nav></details>
                    </Col>
                </Row>
            </Container>
        </Navbar>


    </>
    )
}

export default Header;
